<template>
  <div class="page-content">
    <div class="page-box">
      <div class="box-title">操作日志</div>
      <el-table
        :data="tableData">
        <el-table-column
          prop="callStime"
          label="时间">
        </el-table-column>
        <el-table-column
          prop="ipAddr"
          label="IP">
        </el-table-column>
        <el-table-column
          prop="regionCode"
          label="地区">
        </el-table-column>
        <el-table-column
          prop="logDescription"
          label="操作">
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {system} from '@/api'

export default {
  name: 'OperationLog',

  data () {
    return {
      page: {
        pageSize: 10,
        pageNo: 1
      },
      totalPage: 0,
      tableData: []
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      let {data, page} = await system.getOperationLog(this.page)
      this.loading = false
      this.tableData = data
      this.totalPage = page.total
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNo = arg
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-box {
  margin-bottom: 12px;
  padding: 24px;
  border: 1px solid #dfe1e7;
  background-color: #fff;
  .box-title {
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 24px;
  }
  /deep/ .el-table {
    margin-top: 22px;
    .table-header th {
      background-color: #f6f9f6;
    }
    .table-header th,
    td {
      text-align: center;
    }
  }
}
</style>

<style lang="scss">

</style>
